var path = 'views/value/radio_buttons.html';
var html = "<div ng-include=\"'views/edit/possible_values.html'\"></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;